var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prepare-for-charge"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('m.preparingTitle')))]),_c('h2',[_vm._v(_vm._s(_vm.subtitle || _vm.$t('m.preparingSubtitle')))]),_c('LoadingIcon',{staticClass:"loading-icon"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }